import { render } from "./dpp-title.vue?vue&type=template&id=11dcb709"
import script from "./dpp-title.js?vue&type=script&lang=js"
export * from "./dpp-title.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__